/**
 * axiosConfig.js
 * Global axios interceptors for handling authentication errors
 *
 * NOTE: This module exports a function that accepts the axios instance to configure.
 * It must be called with the actual api instance used by the app.
 */

import { USER_DATA_KEY } from '../constants';

/**
 * Setup axios interceptors on a specific axios instance
 * @param {Object} axiosInstance - The axios instance to configure (usually the 'api' instance)
 * @param {Function} onUnauthorized - Callback to execute on 401 errors (usually logout)
 */
export const setupAxiosInterceptors = (axiosInstance, onUnauthorized) => {
  // Response interceptor to handle 401 errors globally
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const code = error.response?.data?.code;
        const isInactivity = code === 'SESSION_INACTIVE';

        console.warn(`🔒 Authentication error (401) - ${isInactivity ? 'Session inactive' : 'Token may be expired or invalid'}`);

        // Clear stored display data (auth cookie is cleared by server on logout)
        localStorage.removeItem(USER_DATA_KEY);

        // Execute callback (usually logout), pass inactivity flag
        if (onUnauthorized) {
          onUnauthorized(isInactivity);
        }

        // Redirect to login if not already there
        if (window.location.pathname !== '/login') {
          console.warn('🔄 Redirecting to /login due to 401 error');
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
